<template>
    <div class="vuetify-wrapper mx-auto text-center container">
        <v-btn
            @click="isDialogOpen = true"
            min-width="30"
            fab
            small
            class="pharmacists-requests"
        >
            <v-icon>mdi-account-multiple</v-icon>
            <span v-if="numOfRequests" class="pharmacists-requests-count">
                {{ numOfRequests }}
            </span>
            <span v-if="numOfActiveRequests" class="active-pharmacists-requests-count">
                {{ numOfActiveRequests }}
            </span>
        </v-btn>
        <v-dialog v-model="isDialogOpen" scrollable content-class="v-application" max-width="90vw">
            <v-card :disabled="isLoading" :loading="isLoading" elevation="2">
                <v-card-title>Anfragen durch Freiberufler</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="h5">Freiberufler Können Anfragen senden, die hier gelistet
                            werden</v-col>
                        <v-col cols="12">
                            <div>
                                <b>Apotheke:</b>
                                <a v-if="pharmacyHref" :href="pharmacyHref" target="_blank">
                                    {{ pharmacyLabel }}
                                </a>
                                <span v-else>{{ pharmacyLabel }}</span>
                            </div>
                            <v-row no-gutters>
                                <v-col cols="auto" class="font-weight-bold">Termin:</v-col>
                                <v-col class="ml-3 pr-4 dates" cols="auto">
                                    <div v-for="appointment in group">
                                        <span :class="appointment.commited && 'committed'">
                                            {{ formatDate(appointment.date) }}
                                        </span>
                                        <span class="ml-2"> {{ appointment.display_time }}</span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="auto" class="font-weight-bold">HBA zwingend notwendig: </v-col>
                                <v-col class="ml-3 hba-required">{{ appointment.hba ? 'ja' : 'nein' }}</v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="auto" class="font-weight-bold">WWS: </v-col>
                                <v-col class="ml-2">{{ pharmacy.erp }}</v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="auto" class="font-weight-bold">Direkt Zusage: </v-col>
                                <v-col class="ml-2 direct-approval">{{ pharmacy.no_approval_required ? 'ja' : 'nein' }}</v-col>
                            </v-row>
                            <v-row v-if="assignedPharmacist?._id" no-gutters>
                                <v-col cols="auto" class="font-weight-bold">Freiberufler: </v-col>
                                <v-col class="ml-2">
                                    <a :href="`/pharmacists/${assignedPharmacist._id}`" target="_blank">
                                        {{ assignedPharmacist.firstname }} {{ assignedPharmacist.lastname }}
                                    </a>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row v-if="numOfRequests && group.length">
                        <v-col>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Datum der Anfrage</th>
                                            <th>Entfernung/ Fahrkosten</th>
                                            <th>WWS | HBA</th>
                                            <th>war schonmal da?</th>
                                            <th>Anmerkungen /Kommentar</th>
                                            <th>Auswählen/Absage</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="!hydrateOnDialogOpen || hasOpenedDialog">
                                        <PharmacistRequestTableRow
                                            v-for="(request, pharmacistId, idx) in (group[0] || appointment).pharmacist_requests"
                                            :key="`${pharmacistId}-${request[2]}-${(group[0] || appointment).wf_state}`"
                                            :request="request"
                                            :pharmacistId="pharmacistId"
                                            :idx="idx"
                                            :knownPharmacists="knownPharmacists"
                                            :assignedPharmacist="assignedPharmacist"
                                            :pharmacy="pharmacy"
                                            :appointment="group[0] || appointment"
                                            :group="group"
                                            :numOfRequests="numOfRequests"
                                            :selection-enabled="selectionEnabled"
                                            :hydration-retry-token="hydrationRetryToken"
                                            @selected-user="$emit('selected-user', $event)"
                                            @is-loading="mutationLoading = $event"
                                            @hydration-started="outstandingHydrations += 1"
                                            @hydration-finished="outstandingHydrations = Math.max(0, outstandingHydrations - 1)"
                                            @requests-updated="getGroup"
                                        />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from 'vuex';
import PharmacistRequestTableRow from "./PharmacistRequestTableRow.vue";

const ACTIVE_STATUSES = ['notset', 'rerequested']

export default {
    props: {
        appointment: Object,
        pharmacy: Object,
        assignedPharmacist: Object,
        knownPharmacists: Array,
        numOfRequests: Number,
        selectionEnabled: {
            type: Boolean,
            default: true,
        },
        hydrateOnDialogOpen: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        PharmacistRequestTableRow,
    },
    data() {
        return {
            isDialogOpen: false,
            outstandingHydrations: 0,
            mutationLoading: false,
            hydrationRetryToken: 0,
            hasOpenedDialog: false,
            group: []
        }
    },
    methods: {
        async getGroup() {
            if (this.appointment.group_id) {
                try {
                    const response = await axios.get(`/api/appointments/fetch_one_appointment?appointment_id=${this.appointment._id}`);
                    this.group = response.data
                } catch (error) {
                    this.alertError(error.message)
                }
            } else {
                this.group = [{ ...this.appointment }]
            }
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })
        },
        ...mapMutations({
            alertError: 'alert/error',
        })
    },
    computed: {
        isLoading() {
            return this.mutationLoading || this.outstandingHydrations > 0;
        },
        pharmacyHref() {
            const pharmacyId = this.pharmacy?._id || this.pharmacy?.pharmacy_id || this.pharmacy?.id;
            return pharmacyId ? `/pharmacies/${pharmacyId}` : null;
        },
        pharmacyLabel() {
            return this.pharmacy?.name || this.pharmacy?.shortname || '';
        },
        numOfActiveRequests() {
            const requests = Object.values((this.group[0] || this.appointment).pharmacist_requests || {});
            return requests.filter(request => ACTIVE_STATUSES.includes(request[2]?.toLowerCase())).length;
        }
    },
    watch: {
        isDialogOpen(isOpen) {
            if (isOpen) {
                this.hasOpenedDialog = true;
                this.hydrationRetryToken += 1;
                this.getGroup();
            }
        }
    },
}
</script>

<style scoped>
    .container {
        width: 100%;
    }
    .pharmacists-requests-count, .active-pharmacists-requests-count {
        width: 1.3em;
        min-width: min-content;
        height: 1.3em;
        color: white;
        position: absolute;
        right: 0;
        border-radius: 50%;
        padding-top: 0.1em;
    }
    .pharmacists-requests-count {
        background: #5e5e5e;
        bottom: 1.15rem;
    }
    .active-pharmacists-requests-count {
        background: #da1818;
        top: 1.6em;
    }
    .dates {
        max-height: 9rem;
        overflow: auto;
    }
    tr th {
        text-align: center;
    }
</style>
